import React, { useContext, useRef } from 'react';
import useBetslip from '../common/useBetslip';
import { ASIAN_HANDICAP, HANDICAP_TYPES_TO_SHOW_WITHOUT_HANDICAP } from '../data/constants';
import { getBetDescription } from '../data/utils/getBetDescription';
import { getConfiguration } from '../data/utils/configuration';
import { getToolTipDesc } from '../data/utils/getToolTipDesc';
import { showMatchDesc } from '../data/utils/showMatchDesc';
import { useHighlightOddChange } from './useHighlightOddChange';
import OddDesc from './OddDesc';
import { BetslipContext } from '../data/betslip/BetslipConf';

export function getOddDesc(odd) {
    let desc = odd.desc;
    const betData = odd.betData;

    if (betData.hideHandicap) {
        desc = `${getBetDescription(betData, true)} ${odd.desc}`;
    } else if (showMatchDesc(odd)) {
        desc = getToolTipDesc(odd);
    } else {
        const conf = getConfiguration();
        if (!betData.calculateHandicapDescription || betData.handicap === 0 || HANDICAP_TYPES_TO_SHOW_WITHOUT_HANDICAP.includes(betData.tipoHandicap) || (conf.nas && ASIAN_HANDICAP.includes(betData.id))) {
            desc = odd.desc;
        }
    }

    return desc;
}

export default function Odd(props) {
    const data = props.data;
    const isBetBuilder = props.isBetBuilder;
    const betslipContext = useContext(BetslipContext);
    const conf = getConfiguration();
    const container = useRef(null);
    useHighlightOddChange(container, data.value, data.matchData.isLive);
    const [addBet, selected] = useBetslip({...data, isBetBuilder});

    if (data == null) {
        return null;
    }

    const desc = data.desc === ' ' ? getOddDesc(data) : data.desc;
    let classes = props.className;

    if (data.betData.pClass != null) {
        classes += ` ${data.betData.pClass}`;
    }

    function getHighlightClass(betId) {
        return betId && betId < 0 ? 'odd-maggiorata ' : '';
    }

    if (data.value == null) {
        return (
            <div className={`xs_odd relative flex items-center justify-between bg-cs1 rounded-lg border border-cs7 ${getHighlightClass(data?.betId)} ${classes}`}>
                <OddDesc desc={desc} />
                <i className="bi-lock-fill px-2" />
            </div>
        );
    }
    const closedForBetBuilder = isBetBuilder && !betslipContext.isBetBuilderOddSelectable(data.matchData.sportRef, data.matchData.pal, data.matchData.avv, data.betData.id, data.betData.handicap, data.id);
	if(closedForBetBuilder){
    	classes += ' closedBetBuilder';
    }
	const styleCloseForBB = closedForBetBuilder? {"filter":"opacity(0.5)", "pointerEvents": "none"} : {};    
    const hideOdd = isBetBuilder && !conf.bbc.sno;

    return (
        <>
            {selected ?
                <div className={`xs_odd relative flex items-center justify-between bg-cs4 rounded-lg border border-cs7 ${getHighlightClass(data?.betId)} ${classes}`} onClick={addBet}>
                    <span className="min-w-[50%] px-1 py-2 rounded-l-lg font-medium text-xs text-cs1 truncate odd-desc-wh">{desc}</span>
                    <div className="h-full w-full pr-1 py-2 text-right font-medium text-xs text-cs1" ref={container}>{hideOdd? '': data.value}</div>
                </div>
                :
                data.highlighted ?
                    <div style={styleCloseForBB} className={"xs_odd relative flex items-center justify-between bg-cs15 rounded-lg border border-cs-15 " + classes} onClick={addBet}>
                        <OddDesc desc={desc} />
                        <div className="h-full w-full pr-1 py-2 text-right font-medium text-xs text-cs10" ref={container}>{hideOdd? '': data.value}</div>
                    </div>
                    :
                    <div  style={styleCloseForBB} className={`xs_odd relative flex items-center justify-between bg-cs1 rounded-lg border border-cs7 ${getHighlightClass(data?.betId)} ${classes}`} onClick={addBet}>
                        <OddDesc desc={desc} />
                        <div className="h-full w-full pr-1 py-2 text-right font-medium text-xs text-cs10" ref={container}>{hideOdd? '': data.value}</div>
                    </div>
            }
        </>
    );
}

export function FullLengthOdd(props) {
    const data = props.data;
    const container = useRef(null);
    useHighlightOddChange(container, data.value, data.matchData.isLive);
    const [addBet, selected] = useBetslip(data);

    if (data == null) {
        return null;
    }

    const desc = data.desc === ' ' ? getOddDesc(data) : data.desc;
    let classes = props.className;

    if (data.betData.pClass != null) {
        classes += ` ${data.betData.pClass}`;
    }

    function getHighlightClass(betId) {
        return betId && betId < 0 ? 'odd-maggiorata ' : '';
    }
    
    if (data.value == null) {
        return (
            <div className={`xs_odd relative flex items-center justify-between bg-cs1 rounded-lg border border-cs7 ${getHighlightClass(data?.betId)} ${classes}`}>
                <span className="shrink-0 px-2 py-2 bg-cs7 rounded-l-lg font-medium text-xs text-cs10">{desc}</span>
                <i className="bi-lock-fill px-2" />
            </div>
        );
    }

    return (
        <>
            {selected ?
                <div className={`xs_odd relative flex items-center justify-between bg-cs4 rounded-lg border border-cs7 ${getHighlightClass(data?.betId)} ${classes}`} onClick={addBet}>
                    <span className="shrink-0 px-2 py-2 rounded-l-lg font-medium text-xs text-cs1">{desc}</span>
                    <div className="h-full w-full px-2 py-2 text-right font-medium text-xs text-cs1" ref={container}>{data.value}</div>
                </div>
                :
                data.highlighted ?
                    <div className={"xs_odd relative flex items-center justify-between bg-cs15 rounded-lg border border-cs-15 " + classes} onClick={addBet}>
                        <span className="shrink-0 px-2 py-2 bg-cs7 rounded-l-lg font-medium text-xs text-cs10">{desc}</span>
                        <div className="h-full w-full px-2 py-2 text-right font-medium text-xs text-cs10" ref={container}>{data.value}</div>
                    </div>
                    :
                    <div className={`xs_odd relative flex items-center justify-between bg-cs1 rounded-lg border border-cs7 ${getHighlightClass(data?.betId)} ${classes}`} onClick={addBet}>
                        <span className="shrink-0 px-2 py-2 bg-cs7 rounded-l-lg font-medium text-xs text-cs10">{desc}</span>
                        <div className="h-full w-full px-2 py-2 text-right font-medium text-xs text-cs10" ref={container}>{data.value}</div>
                    </div>
            }
        </>
    );
}
